import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { AccountingHeading } from 'src/features/accountingHeaders/utils/types';
import { AccountingHeadingFormSchemaValues } from 'src/features/accountingHeaders/utils/formSchema';

const RESOURCE = '/financial-documents/accounting-heading/:id/';

type MutationFnType = typeof mutationFn;

interface DTO extends AccountingHeadingFormSchemaValues {
    id: string;
}
const mutationFn = ({ id, ...data }: DTO): Promise<AccountingHeading> => {
    return axios.put(formatResourcePath(RESOURCE, { id }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateAccountingHeader };
